/**
 * The Events container
 */
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
import Page from "../components/Page/Page-component";

/**
 * MintingSection container used as app default landing page
 */
const TermsAndConditionsTVBundle = (props, context) => {
  const lang = useSelector((state) => state.i18nState.lang);

  return (
    <Page
      id="termsandconditionstvbundle"
      title={context.t("Terms & Conditions TV Bundle")}
    >
      <Container className="my-5">
        <div className="staticTextWrapper">
          {lang === "de" ? (
            <>
              <h1>
                Disclaimer Angebot The Frame TV– Ledger/NFT Bundle - Samsung
                Online Shop | ShopApp
              </h1>

              <p>
                <strong>Aktionszeitraum:</strong> 24.04. - 30.09.2024 23:59 Uhr,
                begrenzt auf 1500 Aktionsgeräte
              </p>

              <p>
                Nur für private Endkund*innen ab 18 Jahren. Bei Erwerb eines (1)
                Samsung The Frame TV (2024) 50 + Zoll oder The Sero (2023)
                („Aktionsgerät&quot;) zwischen dem 24.04.2024 und dem 30.09.2024
                („Aktionszeitraum&quot;) im Samsung Online Shop oder in der
                Samsung Shop App erhalten Endkund*innen eine (1) Gratis-Zugabe
                („Zugabe&quot;). Die Zugabe beinhaltet 2 Komponenten, zum einen
                einen (1) „Ledger Nano X&quot;, zum anderen ein (1) GEN3RATOR
                mit Samsung GEN3 Chip („NFT&quot;). Nach Ablauf der
                Widerrufsfrist oder spätestens nach 6 Wochen versendet Samsung
                an die von den Endkund*innen beim Kauf angegebene E-Mail
                Adressen Gutscheincodes zum Erhalt der Zugabe.
              </p>

              <h2>Ledger</h2>
              <p>
                Endkund*innen können ihren Gutscheincode auf Ledger.com
                verwenden, indem sie einen „Nano X&quot; über{" "}
                <a href="https://shop.ledger.com/pages/samsung-ledger-collaboration">
                  https://shop.ledger.com/pages/samsung-ledger-collaboration
                </a>{" "}
                in ihren Einkaufswagen legen und ihren Gutscheincode während des
                Bestellvorgangs eingeben. Vorbehaltlich der oben genannten
                Bedingungen berechtigt Sie der Aktionscode zu einem 100%igen
                Rabatt für einen „Ledger Nano X&quot; und kostenlosen Versand.
                Der Aktionscode ist nur für den Erhalt des „Ledger Nano X&quot;
                und im Zeitraum vom 09.05.2024 – 31.12.2024 gültig.
              </p>

              <h2>NFT</h2>
              <p>
                Endkund*innen können ihren Gutscheincode auf Samsung Gen3 |
                Samsung GEN|3|GATE verwenden, indem sie sich dort mit ihrem
                Wallet anmelden oder dort ein Wallet erstellen, und dann unter
                Eingabe des Gutscheincodes kostenfrei einen GEN3RATOR
                aktivieren. Ein aktivierter GEN3RATOR ermöglicht dem Besitzer
                zwischen dem 03.06.2024 und 31.12.2024 eines der folgenden
                Partner-NFTs oder Samsung-Produkte zu erhalten:
              </p>
              <ul>
                <li>
                  <strong>Samsung Produkte:</strong> Samsung Galaxy S23 Ultra (5
                  Stück), Samsung Galaxy S24 Ultra (5 Stück), Samsung web3 TV
                  Bundle (2 Stück), Ledger Nano X Standard (5 Stück) – jeweils
                  verfügbar über den Samsung GEN3RATOR.
                </li>
                <li>
                  <strong>Partner NFTs:</strong> Verfügbar von Illuvium (2000
                  Stück), Wilder World (15 Stück), World of Women (75 Stück),
                  Belvedere Museum (75 Stück) – jeweils aktivierbar durch den
                  entsprechenden GEN3RATOR. Das dabei entstehende NFT-Kunstwerk
                  ist kein reales Produkt. Es ist ein rein digitales Asset.
                </li>
              </ul>

              <p>
                Pro teilnehmendem Endkund*in Teilnahme mit maximal fünf (5)
                Aktionsgeräten und nur solange der Vorrat bzw. das Budget
                reicht. Bei endgültiger Kaufrückabwicklung innerhalb von zwölf
                (12) Monaten ist die Zugabe zurückzugeben bzw. Wertersatz zu
                leisten. Eine Barauszahlung ist ausgeschlossen. Samsung behält
                sich eine vorzeitige Beendigung der Aktion vor, insbesondere
                wenn das Budget ausgeschöpft ist. Die Aktion ist nicht
                kombinierbar mit anderen Aktionen, Services, Gutscheinen,
                Zuschüssen, Boni oder Rabattaktionen von Samsung, es sei denn,
                dies wird in den Teilnahmebedingungen der anderen Aktion
                ausdrücklich zugelassen. Ausrichter der Aktion ist Samsung
                Electronics GmbH, Am Kronberger Hang 6, 65824 Schwalbach/Taunus,
                Deutschland.
              </p>

              <h2>Teilnahmeberechtigte Geräte</h2>
              <p>
                Die nachfolgend aufgelisteten Geräte sind teilnahmeberechtigte
                The Frame TV bzw. The Sero Aktionsgeräte:
              </p>
            </>
          ) : (
            <>
              <h1>
                Disclaimer for The Frame TV– Ledger/NFT Bundle - Samsung Online
                Shop | ShopApp
              </h1>

              <p>
                <strong>Promotion Period:</strong> April 24 - September 30,
                2024, 11:59 PM, limited to 1,500 promotional devices
              </p>

              <p>
                This promotion is for private end customers over 18 years of
                age. When purchasing one (1) Samsung The Frame TV (2024) 50+
                inches or The Sero (2023) (&quot;Promotional Device&quot;)
                between April 24, 2024, and September 30, 2024 (&quot;Promotion
                Period&quot;) in the Samsung Online Shop or the Samsung Shop
                App, end customers receive one (1) free bonus
                (&quot;Bonus&quot;). The Bonus includes two components: one (1)
                &quot;Ledger Nano X&quot; and one (1) GEN3RATOR with a Samsung
                GEN3 Chip (&quot;NFT&quot;). After the withdrawal period or at
                most within six weeks, Samsung sends voucher codes to the email
                addresses provided by end customers during purchase for
                obtaining the Bonus.
              </p>

              <h2>Ledger</h2>
              <p>
                End customers can use their voucher code on Ledger.com by adding
                a &quot;Nano X&quot; to their cart at{" "}
                <a href="https://shop.ledger.com/pages/samsung-ledger-collaboration">
                  https://shop.ledger.com/pages/samsung-ledger-collaboration
                </a>{" "}
                and entering their voucher code during checkout. Subject to the
                conditions above, the promotional code entitles you to a 100%
                discount for one &quot;Ledger Nano X&quot; and free shipping.
                The promotional code is only valid for obtaining the
                &quot;Ledger Nano X&quot; and is valid from May 9, 2024, to
                December 31, 2024.
              </p>

              <h2>NFT</h2>
              <p>
                End customers can use their voucher code on Samsung Gen3 |
                Samsung GEN|3|GATE by logging in with their wallet or creating a
                wallet there, and then activating a GEN3RATOR for free with the
                voucher code. An activated GEN3RATOR allows the owner to receive
                one of the following partner NFTs or Samsung products from June
                3, 2024, to December 31, 2024:
              </p>
              <ul>
                <li>
                  <strong>Samsung Products:</strong> Samsung Galaxy S23 Ultra (5
                  pieces), Samsung Galaxy S24 Ultra (5 pieces), Samsung web3 TV
                  Bundle (2 pieces), Ledger Nano X Standard (5 pieces), each
                  available through the Samsung GEN3RATOR.
                </li>
                <li>
                  <strong>Partner NFTs:</strong> Available from Illuvium (2,000
                  pieces), Wilder World (15 pieces), World of Women (75 pieces),
                  Belvedere Museum (75 pieces), each activatable through the
                  corresponding GEN3RATOR. The NFT artwork created through this
                  process is not a physical product; it is purely a digital
                  asset.
                </li>
              </ul>

              <p>
                Each participating end customer can participate with a maximum
                of five (5) promotional devices and only while supplies last or
                until the budget is exhausted. If a final purchase is reversed
                within twelve (12) months, the Bonus must be returned or
                equivalent compensation must be paid. Cash payment is excluded.
                Samsung reserves the right to end the promotion early,
                especially if the budget is exhausted. The promotion cannot be
                combined with other Samsung promotions, services, vouchers,
                grants, bonuses, or discount promotions unless explicitly stated
                in the terms and conditions of the other promotion. The
                organizer of the promotion is Samsung Electronics GmbH, Am
                Kronberger Hang 6, 65824 Schwalbach/Taunus, Germany.
              </p>

              <h2>Eligible Devices</h2>
              <p>
                The following listed devices are eligible for participation as
                The Frame TV or The Sero promotional devices:
              </p>
            </>
          )}
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Productname</th>
                <th scope="col">Model Code</th>
                <th scope="col">EEK</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">
                  50&quot; QLED 4K The Frame LS03D Smart TV (2024)
                </td>
                <td>GQ50LS03DAUXZG</td>
                <td>
                  <img src="/eek_labels/g.png" height="24px" alt="eek-g" />
                </td>
              </tr>
              <tr>
                <td scope="row">
                  55&quot; QLED 4K The Frame LS03D Smart TV (2024)
                </td>
                <td>GQ55LS03DAUXZG</td>
                <td>
                  <img src="/eek_labels/g.png" height="24px" alt="eek-g" />
                </td>
              </tr>
              <tr>
                <td scope="row">
                  65&quot; QLED 4K The Frame LS03D Smart TV (2024)
                </td>
                <td>GQ65LS03DAUXZG</td>
                <td>
                  <img src="/eek_labels/g.png" height="24px" alt="eek-g" />
                </td>
              </tr>
              <tr>
                <td scope="row">
                  75&quot; QLED 4K The Frame LS03D Smart TV (2024)
                </td>
                <td>GQ75LS03DAUXZG</td>
                <td>
                  <img src="/eek_labels/f.png" height="24px" alt="eek-f" />
                </td>
              </tr>
              <tr>
                <td scope="row">
                  85&quot; QLED 4K The Frame LS03D Smart TV (2024)
                </td>
                <td>GQ85LS03DAUXZG</td>
                <td>
                  <img src="/eek_labels/g.png" height="24px" alt="eek-g" />
                </td>
              </tr>
              <tr>
                <td scope="row">43&quot; QLED 4K The Sero 4K LS05BG (2023)</td>
                <td>GQ43LS05BGUXZG</td>
                <td>
                  <img src="/eek_labels/g.png" height="24px" alt="eek-g" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
TermsAndConditionsTVBundle.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default withRouter(TermsAndConditionsTVBundle);
